export default {
  // 按钮文本
  buttons: {
    payNow: 'Pay now',
  },

  // 错误消息
  messages: {
    unexpectedError: 'An unexpected error occurred.',
  },

  // 开发注释
  dev: {
    paymentMethodsNote: 'Payment methods are dynamically displayed based on customer location, order amount, and currency.',
    previewLink: 'Preview payment methods by transaction',
  },
};
